"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.collectDeviceMetrics = collectDeviceMetrics;
async function collectDeviceMetrics(provider) {
  try {
    if (!provider) return null;
    const metrics = await provider.collectAll();
    if (!metrics) return null;
    return metrics;
  } catch (err) {
    console.error('Error while fetching metrics', err);
    return null;
  }
}